import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-cabecera-pp-fw',
  templateUrl: './cabecera-pp-fw.component.html',
  styleUrls: ['./cabecera-pp-fw.component.css']
})
export class CabeceraPpFwComponent implements OnInit {

  flgLogin = false;

  usuario = '';

  @Output() abrirMenuOut = new EventEmitter();
  @Output() salirOut = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  setUsuario(data: string) {

    this.usuario = data;

  }

  setFlgLogin(flgValor: boolean) {
    this.flgLogin = flgValor;
  }

  _openNav() {

    window.open('#', '_blank');

  }

  _clicLogo() {

    if (this.flgLogin) {

      this.abrirMenuOut.emit();

    } else {


      this.salirOut.emit();

    }


  }


  // _retornar(){

  //   console.log("========0retornar");

  //   this.salirOut.emit();



  // }
  //   if(this.flagMenu){
  //    document.getElementById("mySidenav").style.width = "250px";
  //    this.flagMenu = false;
  //  }else{
  //    document.getElementById("mySidenav").style.width = "0px";
  //    this.flagMenu = true;
  //  }

}
